import styles from './FindStoreDrawer.module.scss';

export const stylesDrawer = {
  header: styles.header,
  content: styles.content,
  aside: styles.aside,
};

export const buttonCloseSize = {
  width: 30,
  height: 30,
};
